import React from 'react';

const SimpleList = (props) => {
  const { list, keyName } = props;
  return <ul style={{ padding: 0 }}>{list.map((it, idx) => (<li key={idx}>{it[keyName]}</li>))}</ul>
}

export default SimpleList;
